import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import i18next from 'i18next'
import { getActivityId, getActivityUserActivityId } from 'store/entities/activity/selectors'
import {
  getIdentityActions,
  getIdentityUserData,
  isSocialActivatedForIdentityOrganization,
  getIdentityCanCompletePreviousActivity,
  getIdentityLastUserActivity,
} from 'store/entities/identity/selectors'
import { DID } from 'app/constants/identityActions'
import { activityActions, sendYesterdayActivity } from 'store/entities/identity/actions'
import { getUIUserActivityActionsButtonsDisabled, getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import UserActivityControlPanelActivityActions from './UserActivityControlPanelActivityActions'
import { modal } from 'store/entities/modal/actions'
import ConfirmOrCancel from 'app/components/Modals/ConfirmOrCancel'

const mapStateToProps = createStructuredSelector({
  activityId: getActivityId,
  userActivityId: getActivityUserActivityId,
  actions: getIdentityActions,
  isDisabled: getUIUserActivityActionsButtonsDisabled,
  identity: getIdentityUserData,
  windowWidth: getUIWindowSizesWidth,
  isSocialActivated: isSocialActivatedForIdentityOrganization,
  showPreviousActivityConfirmModal: getIdentityCanCompletePreviousActivity,
  lastActivity: getIdentityLastUserActivity,
})

const mapDispatchToProps = {
  onCommit: activityActions.commit,
  onDid: activityActions.did,
  onDidnot: activityActions.didnot,
  showModal: modal.show,
  hideModal: modal.hide,
  sendYesterdayActivity,
}

const mergeProps = (
  { activityId, userActivityId, identity, showPreviousActivityConfirmModal, lastActivity, ...restState },
  { onCommit, onDid, onDidnot, showModal, hideModal, sendYesterdayActivity },
  ownProps
) => ({
  ...restState,
  ...ownProps,
  onCommit: () => {
    if (showPreviousActivityConfirmModal) {
      showModal(<ConfirmOrCancel />, {
        confirmBtn: i18next.t('user:I Did It'),
        title: i18next.t('user:Did you complete your previous MicroAction?'),
        handleSubmit: () => {
          sendYesterdayActivity({ activityId: lastActivity.get('id'), actionType: DID })
          hideModal()
        },
      })
    }
    onCommit({ activityId, userActivityId })
  },
  onDid: () => onDid({ activityId, userActivityId }),
  onDidnot: () => onDidnot({ activityId, userActivityId }),
  activityId,
  identityId: identity.get('id'),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserActivityControlPanelActivityActions)
